import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'
import {
  loadHistorySuccess,
  loadHistoryFailure,
  RECORD_HISTORY_LOAD,
  HistoryLoadPayload
} from './actions'

function getURI(
  accountId: string,
  projectId: string,
  moduleName: string,
  recordId: string
) {
  return (
    '/accounts/' +
    accountId +
    '/projects/' +
    projectId +
    '/modules/' +
    moduleName +
    '/records/' +
    recordId +
    '/history'
  )
}

function* loadHistorySaga(action: HistoryLoadPayload) {
  const { accountId, projectId, moduleName, recordId } = action
  try {
    const response = yield call(() =>
      axios.get(getURI(accountId, projectId, moduleName, recordId))
    )
    yield put(loadHistorySuccess(response.data))
  } catch (error) {
    yield put(loadHistoryFailure(error as Error))
  }
}

export function* watch() {
  yield all([takeLatest(RECORD_HISTORY_LOAD, loadHistorySaga)])
}
